import type { ColumnsType } from "antd/es/table";
import { Button, Popconfirm } from "antd";
// import { langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";

// const lang = langPage?.card.record;

export const DEFAULT_QUERY_DATA = {
    Email: null,
    Address: null,
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    const { networkOptions } = props;
    return [
        {
            title: '用户邮箱',
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: '地址',
            type: "input",
            field: "Address",
            allowClear: true,
        },
        {
            title: '网络',
            type: "select",
            field: "NetworkId",
            allowClear: true,
            options: networkOptions,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, deleteData, loading,} = props;
    return [
        {
            title: '序号',
            dataIndex: "Index",
            render: (value, record, index) => {
                return index + 1
            }
        },
        {
            title: 'id',
            dataIndex: "Id",
        },
        {
            title: '用户邮箱',
            dataIndex: "Email",
            render(value:any, record:any) {
                return record.Member?.Email
            },
        },
        {
            title: '网络',
            dataIndex: "Network",
        },
        {
            title: '地址',
            dataIndex: "Address",
        },
        {
            title: '创建时间',
            dataIndex: "CreatedAtString",
        },
        {
            title: "操作",
            dataIndex: "ops",
            width: 210,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            onClick={() => operationRef?.current?.changeVisible(row, 'update')}
                        >编辑</Button>
                        <Popconfirm title={"确认删除该钱包地址吗？"} onConfirm={() => deleteData?.({ AddressId: row.Id })} >
                            <Button size="small" type="link" loading={loading} className="pdl0 pdr0">删除</Button>
                        </Popconfirm>
                    </div>
                )
            }
        }
    ]
}


export const generateOperationFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: '地址',
            type: "input",
            field: "Address",
        },
    ];
}



